export enum IOType {
  INPUT = "input",
  OUTPUT = "output",
}
